/**
 * Einheitliches „Zurück“ (Flori 01.11.2026): immer links oben über dem Seitentitel, mit Pfeil und demselben Text.
 * `BackLink` ist ein echter Router-Link (Mittelklick, neuer Tab), `BackButton` für Ziele, die erst beim Klick feststehen.
 */
import { Anchor, Group, type AnchorProps } from '@mantine/core';
import { createLink } from '@tanstack/react-router';
import { forwardRef, type AnchorHTMLAttributes, type ButtonHTMLAttributes } from 'react';
import { t } from '../texts.js';

function Arrow() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M15 18l-6-6 6-6" />
    </svg>
  );
}

function Content() {
  return (
    <Group gap={2} component="span" wrap="nowrap">
      <Arrow />
      {t('common.back')}
    </Group>
  );
}

const BackAnchor = forwardRef<HTMLAnchorElement, AnchorProps & AnchorHTMLAttributes<HTMLAnchorElement>>(function BackAnchor({ children: _children, ...props }, ref) {
  return (
    <Anchor component="a" ref={ref} size="sm" fw={500} w="fit-content" {...props}>
      <Content />
    </Anchor>
  );
});

/** Router-Link mit Pfeil und „Zurück“; Ziel wie bei `Link` (`to`, `params`). */
export const BackLink = createLink(BackAnchor);

export function BackButton({ onClick }: { onClick: ButtonHTMLAttributes<HTMLButtonElement>['onClick'] }) {
  return (
    <Anchor component="button" type="button" size="sm" fw={500} w="fit-content" onClick={onClick}>
      <Content />
    </Anchor>
  );
}
